import { render, staticRenderFns } from "./Subcomment.vue?vue&type=template&id=ddc52222&"
import script from "./Subcomment.vue?vue&type=script&lang=js&"
export * from "./Subcomment.vue?vue&type=script&lang=js&"
import style0 from "./Subcomment.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports